import IconButton from '@/components/Buttons/IconButton';
import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import Ghost from '@/images/Ghost.svg';
import styled from '@emotion/styled';
import CloseIcon from '@mui/icons-material/Close';
import { Modal, Typography } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { useState } from 'react';
import { ListItemIcon, ListItemText } from '../components';
import { SaveAsTemplateForm } from './SaveAsTemplateForm';

const ModalContent = styled.div`
    position: absolute;
    border-radius: 8px;
    padding: 24px;
    overflow: auto;
    width: 50vw;
    background: white;
    font-size: 16px;
    max-height: 90vh;

    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
`;

interface Props {
    projectId: string;
    closeMenu: () => void;
}

export const SaveAsTemplateMenuItem = ({ projectId, closeMenu }: Props) => {
    const [open, setOpen] = useState<boolean>(false);

    const handleClose = () => {
        setOpen(false);
        closeMenu();
    };

    return (
        <MenuItem onClick={() => setOpen(true)}>
            <ListItemIcon>
                <MaskedIcon src={Ghost} size="24px" />
            </ListItemIcon>

            <ListItemText>Save as Template</ListItemText>

            <Modal open={open} onClose={handleClose}>
                <ModalContent>
                    <Header>
                        <Typography variant="h3">Save as Template</Typography>

                        <IconButton ariaLabel="close" onClick={handleClose}>
                            <CloseIcon color="secondary" fontSize="large" />
                        </IconButton>
                    </Header>

                    <SaveAsTemplateForm projectId={projectId} handleClose={handleClose} />
                </ModalContent>
            </Modal>
        </MenuItem>
    );
};
